import Card from './src/JsmCard.vue'

Card.install = (Vue) => {
  Vue.component(Card.name, Card)
}

export default Card
